import { EntryArchiveExportStatus } from 'chaika-enums';

export const enum EntryArchiveExportEvents {
    Finished = 'EntryArchiveExportFinished',
}

interface EntryArchiveExportEventData<Body = {}> {
    body: Body;
    name: EntryArchiveExportEvents;
    entityId: string;
    entityType: 'EntryArchiveExport';
    occurredOn: string;
}

export interface EntryArchiveExportFinishedBody {
    exportId: string;
    ehrId: string;
    status: EntryArchiveExportStatus;
    filePath?: string;
}

export interface EntryArchiveExportFinishedEventData
    extends EntryArchiveExportEventData<EntryArchiveExportFinishedBody> {}
